import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-517798b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "container" }, null, -1))

import { onMounted, onUnmounted, ref, watch, toRef } from 'vue'
import AMapLoader from '@amap/amap-jsapi-loader'
import _ from 'lodash'


import { defineComponent } from 'vue'
import { CSSImageType } from 'html2canvas/dist/types/css/types/image'
const __default__ = defineComponent({
  name: 'GdMap',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lat: {
    type: Number,
    default: 0,
  },
  lng: {
    type: Number,
    default: 0,
  },
  city: {
    type: String,
    default: '110000',
  },
},
  emits: ["updateLngLat"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'updateLngLat', payload: { lat: number; lng: number }): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

let map: any = null
let marker: any = null
let AMap: any, AMapSearch: any, clickListener: any



const searchLoading = ref(false)
let searchLocaltionList = ref<Array<{ value: string; id: number; label: string }>>([])
const searchKey = ref('')
onMounted(async () => {
  window._AMapSecurityConfig = {
    securityJsCode: 'fde2b46f5b7f0c021ae674b049fdd68d',
  }
  AMap = await AMapLoader.load({
    key: 'ffe6e7031187102787691cdefd5eafce', // 申请好的Web端开发者Key，首次调用 load 时必填
    version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
    plugins: ['AMap.PlaceSearch', 'AMap.DistrictSearch'], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
  })
  map = new AMap.Map('container', {
    viewMode: '3D', // 是否为3D地图模式
    zoom: 13, // 初始化地图级别,
  })

  initMap()
})
const makeMarker = () => {
  map.clearMap()
  marker = new AMap.Marker({
    icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
    offset: new AMap.Pixel(-30, -60),
    draggable: true,
  })
  marker.setPosition([Number(props.lng), Number(props.lat)])
  map.add(marker)
  map.setCity(props.city)
  if (props.lat && props.lng) {
    map.setCenter([props.lat, props.lng].join(','))
    marker.setPosition([Number(props.lng), Number(props.lat)])
    marker.on('dragend', (e: any) => {
      const { lnglat } = e
      emits('updateLngLat', { lng: lnglat.lng, lat: lnglat.lat })
    })
  }

  console.log(marker)
}
const initMap = () => {
  map.on('complete', function () {
    console.log('地图加载完成！')
    makeMarker()
  })

  // // 添加地图点击事件监听器
  clickListener = map.on('click', (e: any) => {
    const { lnglat } = e
    const position = [lnglat.getLng(), lnglat.getLat()]
    marker.setPosition(position)
    emits('updateLngLat', { lng: lnglat.getLng(), lat: lnglat.getLat() })
  })
  AMapSearch = new AMap.PlaceSearch({
    pageSize: 8,
    pageIndex: 1,
    city: props.city,
    citylimit: true, // 限制搜索范围为当前城市
  })
}
watch(searchKey, (val) => {
  map.setCenter(val.split(','))
  marker.setPosition(val.split(','))
  emits('updateLngLat', { lat: Number(val.split(',')[1]), lng: Number(val.split(',')[0]) })
})

watch(
  () => props.city,
  () => {
    makeMarker()
  },
)
watch(
  () => props.lat,
  () => {
    if (props.lat && props.lng) {
      makeMarker()
    }
  },
)
const handleSearchLocaltion = _.debounce(async (val: string) => {
  AMapSearch.search(val, function (status: any, result: any) {
    if (status === 'complete' && result.info === 'OK') {
      searchLocaltionList.value = []
      searchLocaltionList.value = result.poiList.pois.map((poi: any) => ({
        value: [poi.location.lng, poi.location.lat].join(','),
        label: poi.name,
        id: poi.id,
      }))
    }
  })
}, 800)

onUnmounted(() => {
  map?.off('click', clickListener)
  map?.destroy()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_el_select, {
      class: "search-input",
      modelValue: searchKey.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchKey).value = $event)),
      filterable: "",
      remote: "",
      "reserve-keyword": "",
      placeholder: _ctx.$t('Operation.pleaseEnterKeyword'),
      "remote-method": _unref(handleSearchLocaltion),
      loading: searchLoading.value,
      style: {"width":"240px"}
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(searchLocaltionList), (item) => {
          return (_openBlock(), _createBlock(_component_el_option, {
            key: item.id,
            label: item.label,
            value: item.value
          }, null, 8, ["label", "value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "placeholder", "remote-method", "loading"])
  ]))
}
}

})